import { ADVANCED_SETTINGS_DEFAULTS } from "../../pages/analyseData/AdvancedSettings/advancedSettings.constants";

const initialState = { ...ADVANCED_SETTINGS_DEFAULTS };

const advancedSettingsReducer = (state = initialState, action) => {
  switch (action.type) {
    case "STORE_ADVANCED_SETTINGS":
      return { ...state, ...action.payload };
    case "RESET_ADVANCED_SETTINGS":
      return { ...initialState };
    default:
      return state;
  }
};

export default advancedSettingsReducer;
